import React, { useState } from "react";
import { SectionData, ComponentRenderProps, renderFunctions } from "./index";
//import generateProductCards from "@/components/products/shop_product_cards";
import { prepareCardsForBuilderProductsGrid } from "@/translator";
import { getBrandPathEntry } from "./getCms";
import { handleProductSelection } from "./shared";
import Title from "./Title";
import Product from "@/components/cms_renderer/Product";

interface ProductsCarouselProps {
    sectionData: SectionData;
    props: ComponentRenderProps;
}

const ProductsCarousel = ({ sectionData, props }: ProductsCarouselProps): JSX.Element | null => {
    const { vendorName, userInfo, favorites, setFavorites } = props;
    if (!sectionData.items || sectionData.items.length === 0) {
        return sectionData.title ? <Title sectionData={sectionData} props={props} /> : null;
    }

    /*     const items2 = generateProductCards(
            prepareCardsForBuilderProductsGrid(sectionData.items as any[], getBrandPathEntry(vendorName as string)),
            handleProductSelection,
            (sectionData.uiCompType?.options?.height || "320px"),
            sectionData.trackId ?? 'productsCarousel_',
            undefined,
            undefined,
            undefined,
            favorites,
            setFavorites,
            userInfo?.cId
        ); */

    const items = sectionData.items.map((item, index) => {
        return (
            <Product
                card={item as any}
                favorites={favorites}
                setFavorites={setFavorites}
                customerId={userInfo?.cId}
                onClick={(e, card) => handleProductSelection(e, card)}
                height={"320"}
                width={"320"}
                pageName={sectionData.pageName}
            />
        );
    });
    const CustCarouselComponent = renderFunctions.CustCarousel;
return <CustCarouselComponent sectionData={{ ...sectionData, items: items }} props={props} />;
    // return renderFunctions.CustCarousel({ ...sectionData, items2 }, props);


}

export default ProductsCarousel;
